import {inject, observer} from "mobx-react";
import React, {useEffect} from "react";

import {RbAdBannerFeedListStore} from "../../lib/RbAdBannerFeedListStore";
import {RbAdBannerFeedListController} from "../../lib/RbAdBannerFeedListController";

import "./RbAdBannerFeedList.styl";

export interface IRbAdBannerFeedListProps {
    store?: RbAdBannerFeedListStore;
    ctrl?: RbAdBannerFeedListController;
}

export const RbAdBannerFeedList: React.FC<IRbAdBannerFeedListProps> = inject(
    "store", "ctrl"
)(
    observer((props) => {
        useEffect(() => {
            props.ctrl?.start();

            return () => {
                props.ctrl?.end();
            };
        }, [props.ctrl]);

        return null;
    })
);
